import "./PrivacyNotice.module.css";
import Header from "@/reusable_sections/Header";
import ArticleContentIguReplacement from "./sections/ArticleContentIguReplacement";
import Footer from "@/reusable_sections/Footer";
export default function PrivacyNoticePage() {
  return <div>
      <Header />
      <ArticleContentIguReplacement />
      <Footer />
    </div>;
}